import React, { FC, useEffect, useState, useContext, useCallback } from 'react';
import './styles.css';
import ManagementCourseBG from 'src/assets/img/management-courses-new.jpg';
import CallNow from 'src/assets/img/call-now.svg';
import SearchIcon from 'src/assets/img/icons/search.svg';
import IIITBLOGO from 'src/assets/img/iiitb_logo.png';
import axios1 from 'axios';
import axios from 'src/utils/axios';
import { Autocomplete } from '@material-ui/lab';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Search from 'src/assets/img/icons/search.svg'
import GlobalPopupEnquiry from 'src/components/GlobalPopupEnquiry';
interface schlorshiptype {
    school_name: string;
    school_slug: string;
}
const SearchHeader: FC<{ getSchoollist: any }> = ({ getSchoollist }) => {
    const [num, setNum] = React.useState(331231);
    let cancelToken;
    const [collegelist, setcollegelist] = React.useState<schlorshiptype[]>([]);
    const [loading, setloading] = React.useState(false);
    const getSuggestions = async (value) => {
        setloading(true);
        
        if (typeof cancelToken != typeof undefined) {
          cancelToken.cancel("Operation canceled due to new request.")
        }
        cancelToken = axios1.CancelToken.source()
        let url = '';

        const params = {}
        params['searchText'] = value;
        params['searchfrom'] = 'school_name';
        params['size'] = '10';
        const response = await axios.get('api/website/home/topschoolbangalore',  { cancelToken: cancelToken.token, params: params });
        const tags = await response.data.data;
        setcollegelist(tags);
        setloading(false);
    }

    const handleupdateBlog = (event) => {
        if (event && event.target && typeof event.target.value != typeof undefined && event.target.value != null && event.target.value.length > 1) {
          getSuggestions(event.target.value);
        }
    };

    useEffect(()=>{
        //getSuggestions('');
    }, []);
    return (
        <section className="inner-top-header" id="hero" style={{ background: `url(${ManagementCourseBG})` }} >
            <div className="hero-container d-flex">
                <div className="container" >
                    <div className="row top-course-block">
                        <div className="top-course-header">
                            <h1>Find <span>Admission</span> at Top <span>Schools</span> in Karnataka</h1>
                            <div className="spac_02"></div>
                            {/* <form action="" method="post"> */}
                                <div className="col-lg-8">
                                    <div className="hero_explore">
                                    <Autocomplete
                                options={collegelist}
                                onInputChange={(e) => {
                                    handleupdateBlog(e);
                                }}
                                onFocus={(e) => {
                                    setcollegelist([]);
                                }}
                                value=""
                                getOptionLabel={(option) => {
                                    // Value selected with enter, right from the input
                                    if (typeof option === 'string') {
                                      return option;
                                    }
                                    // Add "xxx" option created dynamically
                                    if (option.school_name) {
                                      return option.school_name;
                                    }
                                    // Regular option
                                    return option.school_name;
                                }}
                                renderOption={(option) => <li><a style={{ color:"#000" }} href={`school/${option.school_slug}`}>{option.school_name}</a></li>}
                                noOptionsText=""
                                onChange={(e, value) => {
                                    //console.log(value)
                                }}
                                renderInput={(params) => <TextField  className="serachinlinepadding ex-field" style={{ background: `#fff url(${SearchIcon})`, backgroundRepeat: "no-repeat", backgroundPosition: "20px center" }} placeholder="Find your Schools"  name="text" {...params}
                                InputProps={{
                                    ...params.InputProps,
                                   // className: "search-box",
                                    endAdornment: (
                                    <React.Fragment>
                                        {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                        {params.InputProps.endAdornment}
                                    </React.Fragment>
                                    ),
                                }}
                                />}
                            />
                                   {/*  <img src={SearchIcon} />
                                    <input type="text" placeholder="Find your Schools" name="text" className="ex-field"/>
                                    <input type="submit" className="ex-submit" value="Explore"/> */}
                                    </div>
                                </div>
                                <div className='floatright'>
                                    <GlobalPopupEnquiry className="medical-button btn" />
                                    {/* <a href="#" className="medical-button btn">Apply Now</a> */}
                                </div>
                            {/* </form> */}
                        </div>
                    </div>
                </div>
            </div>
        </section >
    
  );
};

export default SearchHeader;